export function getActiveCommand(api) {
  const commands = api._store.get('commands').get('all');
  const tools = api._store
    .get('commands')
    .get('tools')
    .toJS();
  const activeCommand = tools.find(tool => commands[tool].active);
  return activeCommand;
}



// WEBPACK FOOTER //
// ./src/helper/player.js